import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Index from './index'
import Layout from '../layout.vue'

const basePath = '/v-admin/post-applicant-invitation'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    permission: 'PREMIUM_POST_APPLICANT',
    isAllInclude: true,
    isNewPage: true,
    titleI18nKey: 'admin.company.postApplicant.title.invitation',
    menu: {
      get label () {
        return i18n.t('admin.company.postApplicant.menu.invitation')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: Index,
      meta: {
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.postApplicant.title.invitation'
      }
    }
  ]
}
